















import GitHubCorner from '@/components/GitHubCorner.vue'
import Playground from '@/components/Playground.vue'
import Storage from '@/Storage/components/Storage'

export default {
  components: {
    Playground,
    GitHubCorner,
    Storage
  }
}
